import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="admin-container">
      <!-- <h1>Panel de Administración</h1>
      <div class="admin-menu">
        <a routerLink="users" routerLinkActive="active">Usuarios</a>
        <a routerLink="roles" routerLinkActive="active">Roles</a>
        <a routerLink="videos-config" routerLinkActive="active">Configuración Videos</a>
      </div> -->
      <div class="admin-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [`
    .admin-container {
      padding: 20px;
      //max-width: 1200px;
      margin: 0 auto;
    }
    
    h1 {
      font-size: 24px;
      margin-bottom: 20px;
      color: #333;
    }
    
    .admin-menu {
      margin-bottom: 20px;
      padding: 10px 0;
      border-bottom: 1px solid #e0e0e0;
      
      a {
        margin-right: 20px;
        padding: 8px 12px;
        color: #555;
        text-decoration: none;
        border-radius: 4px;
        
        &:hover {
          background-color: #f5f5f5;
        }
        
        &.active {
          color: #f44336;
          font-weight: bold;
          border-bottom: 2px solid #f44336;
        }
      }
    }
    
    .admin-content {
      min-height: 400px;
    }
  `]
})
export class AdminComponent {
} 